interface IGetEnvArg {
  dv1: string;
  qa1: string;
  prod: string;
}

const getEnv = ({ dv1, qa1, prod }: IGetEnvArg) => {
  const domain = window.location.origin;

  const dv1Patterns = [
    /^https:\/\/adm-kafeteria\.dev\.aws\.mybenefit\.pl$/,
    /^https:\/\/dv1\.dev\.aws\.mybenefit\.pl\/?$/,
    /^https:\/\/dv1-\d+\.omb\.mybenefit\.g4n\.eu$/,
  ];

  const qa1Patterns = [
    /^https:\/\/adm-kafeteria\.staging\.aws\.mybenefit\.pl$/,
    /^https:\/\/qa1\.staging\.aws\.mybenefit\.pl$/,
    /^https:\/\/qa1-\d+\.omb\.mybenefit\.g4n\.eu$/,
  ];

  if (dv1Patterns.some((pattern) => pattern.test(domain))) {
    return dv1;
  }

  if (qa1Patterns.some((pattern) => pattern.test(domain))) {
    return qa1;
  }

  return prod;
};

export default getEnv;
